<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:descShowType="{ row }">
        <div>
          {{ row.operationDesc }}
          <el-tag size="small" :type="'light'" v-if="row.linkData">
            <el-link
              :underline="false"
              type="primary"
              @click="displayDetails(row)"
              >{{ '查看详情' }}
            </el-link>
          </el-tag>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      v-if="advqueryDialogVisible"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      :title="'详情展示'"
      top="10vh"
      destroy-on-close
      append-to-body
    >
      <div style="height:650px;overflow:auto">
        <el-row :gutter="20">
          <el-col :span="24" v-for="(item, index) in dataList" :key="index">
            <h5>
              <b>{{ item.title }}</b>
            </h5>

            <el-col
              :span="24"
              v-for="(datas, index) in item.childrenDataOne"
              :key="index"
            >
              <h6>
                <b> {{ datas.title }}</b>
              </h6>

              <ol>
                <li
                  v-for="(threeData, index) in datas.childrenDataTwo"
                  :key="index"
                >
                  <span> {{ threeData.title }} </span>
                  <ul
                    v-for="(threeList,
                    index) in threeData.childrenDataThreeList"
                    :key="index"
                  >
                    <li v-for="(fourData, index) in threeList" :key="index">
                      <span>
                        {{ fourData.title ? fourData.title : fourData }}</span
                      >
                      <ul
                        v-for="(fiveData, index) in fourData.childrenListFour"
                        :key="index"
                      >
                        <li>
                          {{ fiveData.childrenName }}
                          <ul
                            v-for="(sixData,
                            index) in fiveData.childrenSpecData"
                            :key="index"
                          >
                            <li>{{ sixData }}</li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ol>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      dataList: [],
      advqueryDialogVisible: false,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    displayDetails(row) {
      this.dataList = []
      if (!row.descShowType) return
      let linkData = JSON.parse(row.linkData)
      if (row.descShowType == 'changeOrderConfirm') {
        if (linkData && linkData.changeOrderCode) {
          this.$api
            .changeOrderListGetChangeContentApi({
              changeOrderCode: linkData.changeOrderCode,
            })
            .then((res) => {
              let dataList = JSON.parse(res.body)
              const array = this.sortClass(dataList)
              array.forEach((m) => {
                this.filterData(m, m[0].functionName)
              })
              this.advqueryDialogVisible = true
            })
            .catch(() => {})
        } else {
          this.$message({
            message: '展示关联数据JSON数据缺失',
            type: 'error',
          })
        }
      } else if (row.descShowType == 'cancelRequest') {
        if (linkData && linkData.cancelOrderCode && linkData.orderCode) {
          this.$router.push({
            name: 'order-cancelRequest-detail',
            params: {
              code: linkData.cancelOrderCode,
              orderCode: linkData.orderCode,
              isAudit: false,
              pageType: 'detail',
            },
          })
        } else {
          this.$message({
            message: '展示关联数据JSON数据缺失',
            type: 'error',
          })
        }
      } else {
        this.$message({
          message: '暂不支持该类型展示数据方式',
          type: 'error',
        })
      }
    },
    filterData(selected, title) {
      let data = { title: '', childrenDataOne: [] }
      data.title = title
      let addData = { title: '新增', childrenDataTwo: [] }
      let updateData = { title: '修改', childrenDataTwo: [] }
      let deleteData = { title: '删除', childrenDataTwo: [] }
      for (let index = 0; index < selected.length; index++) {
        let childrenDataThree = { title: '', childrenDataThreeList: [] }
        const iterator = selected[index]

        const detailList = iterator.functionDetail
        let childrenList = []
        let childrenListFour = []
        if (detailList && detailList.length > 0) {
          for (let index = 0; index < detailList.length; index++) {
            const detail = detailList[index]
            childrenList.push(
              detail.fieldName +
                ': ' +
                (detail.oldFieldContent || '""') +
                '--->' +
                detail.newFieldContent
            )
          }
        }
        const children = iterator.childrenList

        if (children && children.length > 0) {
          for (let index = 0; index < children.length; index++) {
            let childrenSpecData = []

            const detail = children[index]

            if (detail.functionDetail && detail.functionDetail.length > 0) {
              for (
                let index = 0;
                index < detail.functionDetail.length;
                index++
              ) {
                const childrenDetail = detail.functionDetail[index]

                childrenSpecData.push(
                  childrenDetail.fieldName +
                    ': ' +
                    (childrenDetail.oldFieldContent || '""') +
                    '--->' +
                    childrenDetail.newFieldContent
                )
              }
            }
            childrenListFour.push({
              childrenSpecData,
              childrenName: detail.childrenName,
            })
          }
          childrenList.push({
            title: children[0].functionName,
            childrenListFour: childrenListFour,
          })
        }

        childrenDataThree.title = iterator.mainName
        childrenDataThree.childrenDataThreeList.push(childrenList)

        if ('add' == iterator.changeType) {
          addData.title = '新增'
          addData.childrenDataTwo.push(childrenDataThree)
        }
        if ('update' == iterator.changeType) {
          updateData.title = '修改'
          updateData.childrenDataTwo.push(childrenDataThree)
        }
        if ('delete' == iterator.changeType) {
          deleteData.title = '删除'
          deleteData.childrenDataTwo.push(childrenDataThree)
        }
      }
      if (addData.childrenDataTwo.length > 0) {
        data.childrenDataOne.push(addData)
      }
      if (updateData.childrenDataTwo.length > 0) {
        data.childrenDataOne.push(updateData)
      }
      if (deleteData.childrenDataTwo.length > 0) {
        data.childrenDataOne.push(deleteData)
      }

      this.dataList.push(data)
    },
    sortClass(sortData) {
      const groupBy = (array, f) => {
        let groups = {}
        array.forEach((o) => {
          let group = JSON.stringify(f(o))
          groups[group] = groups[group] || []
          groups[group].push(o)
        })
        return Object.keys(groups).map((group) => {
          return groups[group]
        })
      }
      const sorted = groupBy(sortData, (item) => {
        return item.functionName // 返回需要分组的对象
      })
      return sorted
    },
  },
}
</script>
